import { CEOrganizationInviteBase } from './ce-organization-invite-base'


export class CEOrganizationInvite extends CEOrganizationInviteBase {

}